import { useInView } from '../../hooks/useInView';

interface AnimatedSectionProps {
  children: React.ReactNode;
  /** Delay before the animation starts (ms) — useful for staggered children */
  delay?: number;
  /** Custom className on the wrapper div */
  className?: string;
  /** Y offset to animate from (px) */
  offset?: number;
}

/**
 * Wraps any content in a fade-in + slide-up animation triggered by scroll.
 * Uses IntersectionObserver — no external libraries needed.
 */
export default function AnimatedSection({
  children,
  delay = 0,
  className = '',
  offset = 28,
}: AnimatedSectionProps) {
  const { ref, inView } = useInView({ threshold: 0.06 });

  return (
    <div
      ref={ref}
      className={className}
      style={{
        opacity: inView ? 1 : 0,
        transform: inView ? 'translateY(0px)' : `translateY(${offset}px)`,
        transition: `opacity 0.6s ease ${delay}ms, transform 0.6s ease ${delay}ms`,
        willChange: 'transform, opacity',
      }}
    >
      {children}
    </div>
  );
}
